import {useEffect} from 'react';
import {useDispatch} from 'react-redux';

import uamService from '@/services/uam/uamService';
import {setIsDataLoading} from '@/state/slices/deviceSlice';

const useUamAssets = ({isDisabled, setIsChargerError, setIsHolderError, codentify, holderCodentify}) => {
    const dispatch = useDispatch();

    const fetchDeviceUamInfo = async (deviceCodentify, isHolder = false, onError) => {
        return uamService.getUamInfo({
            codentify: deviceCodentify,
            isHolder,
            onError: () => {
                onError?.(true);
            },
        });
    };

    useEffect(() => {
        // Skip if disabled or no charger codentify available
        if (isDisabled || !codentify) {
            return;
        }

        const getUamInfo = async () => {
            dispatch(setIsDataLoading(true));

            // Reset error states
            setIsChargerError?.(false);
            setIsHolderError?.(false);

            try {
                const fetchPromises = [fetchDeviceUamInfo(codentify, false, setIsChargerError)];

                // Add holder fetch if codentify is available
                if (holderCodentify) {
                    fetchPromises.push(fetchDeviceUamInfo(holderCodentify, true, setIsHolderError));
                } else {
                    setIsHolderError?.(true);
                }

                await Promise.all(fetchPromises);
            } finally {
                dispatch(setIsDataLoading(false));
            }
        };

        getUamInfo();
    }, [codentify, holderCodentify]);
};

export default useUamAssets;
